import React from 'react';
import { Link } from 'react-router-dom';
import './FeaturedSection.css';

const isInternalLink = (href) => href && href.startsWith('/') && !href.startsWith('//');

const LinkOrAnchor = ({ href, className, children, ...props }) => {
  if (isInternalLink(href)) {
    return (
      <Link to={href} className={className} {...props}>
        {children}
      </Link>
    );
  }
  return (
    <a href={href || '#'} className={className} {...props}>
      {children}
    </a>
  );
};

const FeaturedItem = ({ item }) => {
  return (
    <div className="featured-item">
      <div className="featured-item-image">
        <LinkOrAnchor href={item.link} aria-label={item.imageAlt}>
          <img
            src={item.image}
            width="160"
            height="160"
            alt={item.imageAlt}
          />
        </LinkOrAnchor>
      </div>
      <div className="featured-item-content">
        <h3>{item.title}</h3>
        <p>{item.description}</p>
        <p>
          <LinkOrAnchor href={item.link} className="btn btn--default" role="button">
            {item.buttonText}
          </LinkOrAnchor>
        </p>
      </div>
    </div>
  );
};

const FeaturedSection = ({ title, id, items = [] }) => {
  if (items.length === 0) return null;

  return (
    <section className="featured-section" aria-labelledby={id}>
      <h2 id={id}>{title}</h2>
      <div className="featured-items-grid">
        {items.map((item, index) => (
          <FeaturedItem key={index} item={item} />
        ))}
      </div>
    </section>
  );
};

export default FeaturedSection;

